import paycol0 from "../images/paycol0.png";
import paycol1 from "../images/paycol1.png";
import paycol2 from "../images/paycol2.png";
import paycol4 from "../images/paycol4.png";
import paycol5 from "../images/paycol5.png";

export const pay_dets = [
  {
    id: 1,
    img: paycol0,
    title: "Multi Platform",
    description:
      "Adjust responsive spacing, change font size, hide sections on specific devices.",
  },
  {
    id: 2,
    img: paycol1,
    title: "Verified Payment",
    description:
      "Adjust responsive spacing, change font size, hide sections on specific devices.",
  },
  {
    id: 3,
    img: paycol2,
    title: "Secure Identification",
    description:
      "Adjust responsive spacing, change font size, hide sections on specific devices.",
  },
  {
    id: 4,
    img: paycol4,
    title: "Daily Reports",
    description:
      "Adjust responsive spacing, change font size, hide sections on specific devices.",
  },
  {
    id: 5,
    img: paycol5,
    title: "Secure Cloud Data",
    description:
      "Adjust responsive spacing, change font size, hide sections on specific devices.",
  },
  {
    id: 6,
    img: paycol4,
    title: "Daily Reports",
    description:
      "Adjust responsive spacing, change font size, hide sections on specific devices.",
  },
];
